import ApiSmile from '@/api/api-smile';
import PageData from '@/types/page-data';
import LoadingUtil from '@/util/loading-util';
import MessageUtil from '@/util/message-util';
import React, {useEffect, useState} from 'react';
import './recommend-list.scss';
import PageParam from '@/types/page-param';
import LabelUtil from '@/util/label-util';
import PageContainer from '@/component/page-container';
import PaginationTable, {ColumnType} from '@/component/pagination-table';
import Utils from '@/util/utils';
import {RecommendSource, RecommendState} from '@/model/const';
import {ProfileOutlined} from '@ant-design/icons';
import {NavigateFunction, useNavigate} from 'react-router';
import {RecommendData} from '../types';
import ActionArea from '@/component/action-area';
import {ActionButton} from '@/component/action-area/action-area';

const getColumnData = (navigate: NavigateFunction): ColumnType<RecommendData>[] => {
    const onPressDetail = (record: RecommendData) => {
        navigate(`/recommend/${record.id}`);
    };

    return [
        {
            title: '代码',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            render: (text: string, record: RecommendData) => {
                return (
                    <div className="nameWrap">
                        {text}
                        {record.recommendSource == RecommendSource.SELF && <div className="recommendSourceTag">自</div>}
                    </div>
                );
            },
        },
        {
            title: '推荐状态',
            dataIndex: 'recommendState',
            key: 'recommendState',
            render: (text: string) => LabelUtil.getRecommendState(text),
        },
        {
            title: '推荐买入价格',
            dataIndex: 'recommendBuyPrice',
            key: 'recommendBuyPrice',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '保本极限价',
            dataIndex: 'breakevenPrice',
            key: 'breakevenPrice',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '转股溢价率',
            dataIndex: 'premiumRate',
            key: 'premiumRate',
            render: (text: number) => Utils.formatPercentage(text),
        },
        {
            title: '到期收益率',
            dataIndex: 'yieldToMaturity',
            key: 'yieldToMaturity',
            render: (text: number) => Utils.formatPercentage(text),
        },
        {
            title: '推荐买入时间',
            dataIndex: 'recommendBuyTime',
            key: 'recommendBuyTime',
            render: (text: number) => Utils.formatDate(text),
        },
        {
            title: '推荐卖出时间',
            dataIndex: 'recommendSellTime',
            key: 'recommendSellTime',
            render: (text: number) => Utils.formatDate(text),
        },
        {
            title: '卖出收益率',
            dataIndex: 'profitRate',
            key: 'profitRate',
            render: (text: number, record: RecommendData) => {
                if (record.recommendState !== RecommendState.SELL) {
                    return '--';
                } else {
                    return Utils.formatPercentage(text);
                }
            },
        },
        {
            title: '详情',
            dataIndex: 'detail',
            key: 'detail',
            render: (_text: string, record: RecommendData) => (
                <div className="detailIcon" onClick={() => onPressDetail(record)}>
                    <ProfileOutlined />
                </div>
            ),
        },
    ];
};

const RecommendList = () => {
    const [data, setData] = useState<PageData<RecommendData>>();
    const [pageParam, setPageParam] = useState<PageParam>({page: 0, size: 10});
    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            LoadingUtil.show();
            const response: any = await ApiSmile.getRecommendList(pageParam);
            if (response?.data?.code === 0) {
                setData(response.data.data);
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
            LoadingUtil.hide();
        };

        load();
    }, [pageParam]);

    const onBuyClick = () => {
        navigate('/recommend/0');
    };

    const onSellClick = () => {
        navigate('/recommend/sell');
    };

    const getButtons = () => {
        const buttons: ActionButton[] = [
            {
                text: '推荐买入',
                onClick: onBuyClick,
            },
            {
                text: '推荐卖出',
                onClick: onSellClick,
            },
        ];
        return buttons;
    };

    return (
        <PageContainer>
            <ActionArea buttons={getButtons()} />
            <PaginationTable columns={getColumnData(navigate)} data={data} setPageParam={setPageParam} />
        </PageContainer>
    );
};

export default RecommendList;
